import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import {
  CATEGORY_TYPES,
  AddCategoryAction,
  EditCategoryAction,
  DeleteCategoryAction,
  GetAllCategoriesAction,
  GetCategoriesTreeAction,
  GetOneCategoryAction,
} from './categoryTypes';
import * as Actions from './categoryActions';
import { CategoryApi } from '../api/categoryApi';
import { CategoryGetResponse } from '../model/categoryModel';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';
import { ArticleGetResponse } from '../../article/model/articleModel';
import { ArticleApi } from '../../article/api/articleApi';

function* addCategorySaga(add: AddCategoryAction) {
  try {
    yield put(Actions.setApiCategoryRequestState(API_REQUEST_STATE.LOADING));

    if (add.payload.category.image === '') {
      add.payload.category.image = undefined;
    }

    yield call(CategoryApi.post, add.payload.category);

    yield put(Actions.setApiCategoryRequestState(API_REQUEST_STATE.SUCCEEDED_ADD));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiCategoryRequestError(error.response.data.detail));
    yield put(Actions.setApiCategoryRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

function* editCategorySaga(edit: EditCategoryAction) {
  try {
    yield put(Actions.setApiCategoryRequestState(API_REQUEST_STATE.LOADING));

    if (edit.payload.category.image === '') {
      edit.payload.category.image = undefined;
    }

    yield call(CategoryApi.put, edit.payload.params, edit.payload.category);

    yield put(Actions.setApiCategoryRequestState(API_REQUEST_STATE.SUCCEEDED_EDIT));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiCategoryRequestError(error.response.data.detail));
    yield put(Actions.setApiCategoryRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

function* deleteCategorySaga(edit: DeleteCategoryAction) {
  try {
    let categoryDeleteAt = {
      deleteAt: new Date(),
    };
    yield put(Actions.setApiCategoryRequestState(API_REQUEST_STATE.LOADING));
    // @ts-ignore
    const responseArticle: AxiosResponse<ArticleGetResponse[]> = yield call(ArticleApi.getAll, {
      categoryId: edit.payload.params.id,
    });

    const responseCategory: AxiosResponse<CategoryGetResponse[]> = yield call(CategoryApi.getAll, {
      parent: edit.payload.params.id,
    });
    if (responseArticle.data.length > 0) {
      yield put(Actions.setApiCategoryRequestState(API_REQUEST_STATE.FAILED_DELETE_ARTICLE));
    } else if (responseCategory.data.length > 0) {
      yield put(Actions.setApiCategoryRequestState(API_REQUEST_STATE.FAILED_DELETE_SUBCATEGORY));
    } else {
      yield call(CategoryApi.delete, edit.payload.params, categoryDeleteAt);
      yield put(Actions.setApiCategoryRequestState(API_REQUEST_STATE.SUCCEEDED_DELETE));
    }
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiCategoryRequestError(error.response.data.detail));
    yield put(Actions.setApiCategoryRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

function* getAllCategoriesSaga(getAll: GetAllCategoriesAction) {
  try {
    yield put(Actions.setApiCategoriesRequestState(API_REQUEST_STATE.LOADING));

    const response: AxiosResponse<CategoryGetResponse[]> = yield call(
      CategoryApi.getAll,
      getAll.payload.categoryFilter,
    );

    yield put(Actions.setApiCategoriesRequestState(API_REQUEST_STATE.SUCCEEDED_GET));
    yield put(Actions.getAllCategoriesSuccess(response.data));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiCategoriesRequestError(error.response.data.detail));
    yield put(Actions.setApiCategoriesRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

function* getOneCategorySaga(getOne: GetOneCategoryAction) {
  try {
    yield put(Actions.setApiCategoryRequestState(API_REQUEST_STATE.LOADING));

    const response: AxiosResponse<CategoryGetResponse> = yield call(CategoryApi.getOne, getOne.payload.params);

    yield put(Actions.setApiCategoryRequestState(API_REQUEST_STATE.SUCCEEDED_GET));
    yield put(Actions.getOneCategorySuccess(response.data));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiCategoriesRequestError(error.response.data.detail));
    yield put(Actions.setApiCategoryRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

function* getCategoriesTreeSaga(getCategories: GetCategoriesTreeAction) {
  try {
    const response: AxiosResponse<CategoryGetResponse[]> = yield call(
      CategoryApi.getCategoriesTree,
      getCategories.payload.params,
    );

    yield put(Actions.getCategoriesTreeSuccess(response.data));
  } catch (error) {
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

export default function* watch() {
  yield* [
    takeLatest(CATEGORY_TYPES.ADD, addCategorySaga),
    takeLatest(CATEGORY_TYPES.EDIT, editCategorySaga),
    takeLatest(CATEGORY_TYPES.GET_ALL, getAllCategoriesSaga),
    takeLatest(CATEGORY_TYPES.GET_ONE, getOneCategorySaga),
    takeLatest(CATEGORY_TYPES.GET_TREE, getCategoriesTreeSaga),
    takeLatest(CATEGORY_TYPES.DELETE, deleteCategorySaga),
  ];
}
